import { Component, Input } from '@builder.io/sdk';

import sectionFields from 'molecules/Section/config';

const tableCell = [
  {
    name: 'cell',
    type: 'string',
    enum: [
      { label: 'Check', value: 'check' },
      { label: 'X', value: 'x' },
      { label: 'Text', value: 'text' },
    ],
    required: true,
    defaultValue: 'x',
    helperText: 'Type of cell content: a check mark, an X, or custom text.',
  },
  {
    name: 'text',
    type: 'string',
    showIf: "options.get('cell') === 'text'",
    helperText: 'Text to display if the cell type is set to "Text".',
  },
] as const satisfies DeepReadonly<Input[]>;

const comparisonTableRowFields = [
  {
    name: 'id',
    type: 'text',
    required: true,
    showIf: 'false',
    helperText: 'Auto-generated ID for internal reference. Hidden from the editor.',
  },
  {
    name: 'rowHeading',
    type: 'string',
    helperText: 'Label or heading for this row (e.g., a feature name).',
  },
  {
    name: 'prismatic',
    type: 'object',
    subFields: tableCell,
    helperText: 'Select whether Prismatic supports this feature (check, X, or custom text).',
  },
  {
    name: 'competitor',
    type: 'object',
    subFields: tableCell,
    helperText: 'Select whether the competitor supports this feature (check, X, or custom text).',
  },
] as const satisfies DeepReadonly<Input[]>;

const comparisonTableFields = [
  {
    name: 'competitor',
    type: 'object',
    subFields: [
      {
        name: 'competitorName',
        type: 'string',
        defaultValue: 'Apple',
        helperText: 'Name of the competitor displayed in the table header.',
      },
    ],
    helperText: 'Define the competitor shown in this comparison.',
  },
  {
    name: 'rows',
    type: 'list',
    subFields: comparisonTableRowFields,
    helperText: 'List of features/rows to compare between Prismatic and the competitor.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      if (options.get('rows').length > 0) {
        options.get('rows').forEach((item: Map<string, string>, index: number) => {
          item.set('id', `rows-${index}`);
        });
      }
    },
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const comparisonTableConfig = {
  name: 'Comparison Table',
  inputs: comparisonTableFields,
} as Component;

export type ComparisonCellField = GenerateBuilder<typeof tableCell>;
export type ComparisonTableRowField = GenerateBuilder<typeof comparisonTableRowFields>;
export type ComparisonTableConfigProps = GenerateBuilder<typeof comparisonTableFields>;

export default comparisonTableConfig;
